/* Cats Garage — Collection page:
   (a) navigate on sort selection (keeps filter params)
   (b) sidebar <details data-side-panel>: ships open (no-JS safe); collapse it
       on mobile, force it back open on desktop. */
(function () {
  var selects = Array.prototype.slice.call(document.querySelectorAll('[data-sort-select]'));
  selects.forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  var panels = Array.prototype.slice.call(document.querySelectorAll('[data-side-panel]'));
  if (!panels.length) return;

  var desktop = window.matchMedia('(min-width: 990px)');

  function sync(collapseOnMobile) {
    panels.forEach(function (panel) {
      if (desktop.matches) {
        panel.open = true;
      } else if (collapseOnMobile) {
        panel.open = false;
      }
    });
  }

  var onChange = function () { sync(false); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange);
  else if (desktop.addListener) desktop.addListener(onChange);

  sync(true); // initial load: collapsed on mobile, open on desktop
})();
